import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, MailIcon, GlobeIcon, PhoneIcon } from 'lucide-react';
export function Contact() {
  const details = [{
    icon: <MapPinIcon className="w-5 h-5" data-id="element-20" />,
    label: 'Visit Us',
    lines: ['Indhri Group Pvt. Ltd.', 'Birgunj-8, Opposite of Birat Hotel,', 'Panitanki, Birgunj, Nepal']
  }, {
    icon: <MailIcon className="w-5 h-5" data-id="element-21" />,
    label: 'Email Us',
    lines: ['Info@indhrigroup.com'],
    href: 'mailto:Info@indhrigroup.com'
  }, {
    icon: <GlobeIcon className="w-5 h-5" data-id="element-22" />,
    label: 'Website',
    lines: ['www.erplogiflow.com'],
    href: 'https://www.erplogiflow.com'
  }, {
    icon: <PhoneIcon className="w-5 h-5" data-id="element-23" />,
    label: 'Call Us',
    lines: ['+977 9804237598', '+977 9802059688']
  }];
  return <section id="contact" className="py-24 bg-slate-50" data-id="element-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-26">
          <h2 className="text-accent font-semibold tracking-wide uppercase text-sm mb-3" data-id="element-27">
            Get in Touch
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold text-heading mb-4" data-id="element-28">
            Contact Us
          </h3>
          <p className="text-lg text-slate-600" data-id="element-29">
            Ready to streamline your customer flow? Reach out to the ERPLogiFlow
            team for a demo or any inquiries.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto" data-id="element-30">
          {details.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white border border-slate-200 rounded-xl p-6 flex flex-col" data-id="element-31">
              <div className="w-11 h-11 rounded-lg bg-primary/5 flex items-center justify-center text-primary mb-4" data-id="element-32">
                {item.icon}
              </div>
              <h4 className="font-bold text-heading mb-2" data-id="element-33">{item.label}</h4>
              <div className="text-sm text-slate-600 leading-relaxed space-y-0.5" data-id="element-34">
                {item.lines.map((line, i) => item.href ? <a key={i} href={item.href} className="block text-primary hover:text-accent transition-colors break-words" data-id="element-35">
                      {line}
                    </a> : <p key={i} data-id="element-36">{line}</p>)}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}